<template>
  <v-container fluid fill-height class="custom--container">
    <v-row align-center justify="center">
      <v-col cols="8" offset="2">
        <v-card shaped class="elevation-0 intro--card">
          <!-- STANDARD LAYOUT -->
          <v-row class="justify-center align-center">
            <v-col cols="3" offset="1">
              <v-img
                :src="intro.img"
                class="rounded-circle ma-3"
                :aspect-ratio="1"
              ></v-img
            ></v-col>
            <v-col cols="8"
              ><v-card-title class="text-no-wrap intro--text-title">
                <!-- <div class="about--text-name"> -->
                {{ intro.heading }}

                <!-- </div> -->
              </v-card-title>
              <v-card-text class="intro--text-body">
                <div v-for="(text, index) of intro.body" :key="index">
                  {{ text }}
                </div>
              </v-card-text>
              <v-card-text class="intro--text-body">
                <div v-for="(text, index) of intro.sidenote" :key="index">
                  {{ text }}
                </div>
              </v-card-text></v-col
            >
          </v-row>
        </v-card>
      </v-col>
      <scroll-helper :scroll="intro.scroll" />
    </v-row>
  </v-container>
</template>

<script>
import ScrollHelper from "./ScrollHelper.vue";
export default {
  name: "Introduction",
  components: { ScrollHelper },
  props: ["intro"],
  methods: {},
};
</script>
